module.exports = __webpack_public_path__ + "static/3_3_spam-or-ham_PL-a014d61720958ba78393569a6d96848e.svg";